module.exports = __webpack_public_path__ + "fonts/fa-v2-light-300.04c6f174.eot";